import React from "react";
import { useParams } from "react-router-dom";
import { ClientsManagementProvider } from "../../contexts/ClientsManagementContext";
import ClientDetailsContent from "./ClientDetailsContent";

const ClientDetails: React.FC = () => {
  const { clientId } = useParams<{ clientId: string }>();

  return (
    <ClientsManagementProvider>
      <ClientDetailsContent clientId={clientId!} />
    </ClientsManagementProvider>
  );
};

export default ClientDetails;
